import { useEffect } from "react";
import { QueryClient, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./client";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});
export const useCatalogo = () =>
  useQuery({
    queryKey: ["catalogo"],
    queryFn: ({ signal }) => api.catalogo(signal),
  });
export function useEventosCatalogo() {
  const client = useQueryClient();
  useEffect(() => {
    if (!api.EVENTS_URL) return;
    const events = new EventSource(api.EVENTS_URL);
    let timer: ReturnType<typeof setTimeout>;
    const refrescar = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        void client.invalidateQueries({ queryKey: ["catalogo"] });
        void client.invalidateQueries({ queryKey: ["imagenes"] });
      }, 400);
    };
    events.addEventListener("catalogo_actualizado", refrescar);
    return () => {
      clearTimeout(timer);
      events.close();
    };
  }, [client]);
}
export const usePerfil = (id: string | undefined) =>
  useQuery({
    queryKey: ["perfil", id],
    queryFn: ({ signal }) => api.perfil(id!, signal),
    enabled: !!id,
  });
export const useImagenes = () =>
  useQuery({
    queryKey: ["imagenes"],
    queryFn: ({ signal }) =>
      api.json<{ familia: string; variante: string; imagen_url: string }[]>(
        "productos-imagenes",
        { signal },
      ),
  });
